import { useState, useEffect, useRef } from "react";

export default function MultipleSelectList({
  label,
  options = [],
  value = [],
  setValue = () => {},
  placeholder = "Выберите...",
  inputClass = ""
}) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [filteredOptions, setFilteredOptions] = useState(options);
  const dropdownRef = useRef(null);

  // фильтруем при изменении search или options
  useEffect(() => {
    setFilteredOptions(
      options.filter(opt =>
        opt.label.toLowerCase().includes(search.toLowerCase())
      )
    );
  }, [search, options]);

  // закрытие дропдауна при клике вне
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleOption = (optionValue) => {
    if (!Array.isArray(value)) return;
    if (value.includes(optionValue)) {
      setValue(value.filter(v => v !== optionValue));
    } else {
      setValue([...value, optionValue]);
    }
  };

  return (
    <div className="flex flex-col w-full relative" ref={dropdownRef}>
      {label && (
        <label className="mb-2 text-gray-700 font-medium">{label}</label>
      )}

      <div
        className={`border rounded p-2 w-full cursor-pointer flex justify-between items-center ${inputClass}`}
        onClick={() => setOpen(!open)}
      >
        <span>{value.length ? value.join(", ") : placeholder}</span>
        <span className="ml-2">&#9662;</span>
      </div>

      {open && (
        <div className="absolute z-50 mt-1 w-full bg-white border rounded shadow max-h-60 overflow-y-auto">
          <input
            type="text"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Поиск..."
            className="p-2 w-full border-b"
          />
          {filteredOptions.map(opt => (
            <div
              key={opt.value}
              className={`flex items-center justify-between p-2 cursor-pointer hover:bg-gray-200 ${
                value.includes(opt.value) ? "bg-gray-100" : ""
              }`}
              onClick={() => toggleOption(opt.value)}
            >
              <span>{opt.label}</span>
              {value.includes(opt.value) && (
                <span className="text-green-600 font-bold">✓</span>
              )}
            </div>
          ))}
          {filteredOptions.length === 0 && (
            <div className="p-2 text-gray-500">Ничего не найдено</div>
          )}
        </div>
      )}
    </div>
  );
}
